import {Icon, IRenderFunction, ITextFieldProps, Label, TextField, TooltipHost} from '@fluentui/react';
import React from 'react';
import MarkdownView from "react-showdown";
import {SettingId} from '../../settings/registry';

interface INumberFieldProps {
    value?: number;
    onChange: (value?: number, name?: string) => void;
    label?: string;
    suffix?: string;
    prefix?: string;
    disabled?: boolean;
    placeholder?: string;
    decimal?: boolean;
    toolTip?: string;
    inline?: boolean;
    width?: number;
    readonly?: boolean;
    name?: string;
    onRenderSuffix?: IRenderFunction<ITextFieldProps>
    /** Registry identifier, so documentation can deep-link to this field. */
    settingId?: SettingId;
}

const NumberField: React.FC<INumberFieldProps> = (props) => {
    const [tempNumber, setTempNumber] = React.useState<string | undefined>(props.value?.toString());

    React.useEffect(() => {
        setTempNumber(props.value?.toString());
    }, [props.value]);

    const onBlur = () => {
        if (tempNumber === undefined || tempNumber === '') {
            props.onChange(undefined, props.name);
            return;
        }
        let number = props.decimal ? parseFloat(tempNumber): parseInt(tempNumber);
        if (!isNaN(number)) {
            number = Math.trunc(number * 100) / 100; // Round to 2 decimal places
            props.onChange(number, props.name);
        } else {
            setTempNumber(props.value?.toFixed(2));
        }
    }
    const label = () => {
        if (props.toolTip) {
            return (<TooltipHost content={<MarkdownView markdown={props.toolTip}/>}>
                <div style={{display: "inline-flex"}}>
                    <Label>
                        {props.label}
                        <Icon iconName={'Info'} style={{paddingLeft: '5px'}}/>
                    </Label>
                </div>
            </TooltipHost>)
        }
        return (<Label>{props.label}</Label>)
    }

    const onChange = (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        setTempNumber(newValue ?? '');
    }

    if(props.inline){
        return(
            <div data-setting-id={props.settingId} className={'ac-details-field'} style={{width: props.width ? `${props.width}px` : undefined, display: 'inline-flex', alignItems: 'center'}}>
                <div style={{display: "inline-flex", paddingRight: '5px'}}>
                    {label()}
                </div>
                <TextField
                    name={props.name}
                    disabled={props.disabled}
                    value={tempNumber}
                    onChange={onChange}
                    onKeyDown={(e) => { if(e.key === 'Enter') onBlur()}}
                    onBlur={onBlur}
                    suffix={props.suffix}
                    onRenderSuffix={props.onRenderSuffix}
                    prefix={props.prefix}
                    placeholder={props.placeholder}
                />
            </div>
        )
    }
    return (
        <div data-setting-id={props.settingId}>
            {props.label && label()}
            <TextField
                name={props.name}
                disabled={props.disabled}
                value={tempNumber}
                onChange={onChange}
                onKeyDown={(e) => { if(e.key === 'Enter') onBlur()}}
                onBlur={onBlur}
                suffix={props.suffix}
                prefix={props.prefix}
                placeholder={props.placeholder}
                onRenderSuffix={props.onRenderSuffix}
            />
        </div>)
}

export default NumberField;